module.exports = __webpack_public_path__ + "img/messenger-banner-img-eng.5b9faf13.png";